module.exports = __webpack_public_path__ + "img/Nonsyntenic_orth_1.05bdfbf1.jpg";